/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmployeeCostsByJobRoleAndLocationSummary
 */
export interface EmployeeCostsByJobRoleAndLocationSummary {
    /**
     * 
     * @type {number}
     * @memberof EmployeeCostsByJobRoleAndLocationSummary
     */
    locationId: number;
    /**
     * 
     * @type {string}
     * @memberof EmployeeCostsByJobRoleAndLocationSummary
     */
    locationName: string;
    /**
     * 
     * @type {number}
     * @memberof EmployeeCostsByJobRoleAndLocationSummary
     */
    jobRoleId: number;
    /**
     * 
     * @type {string}
     * @memberof EmployeeCostsByJobRoleAndLocationSummary
     */
    jobRoleName: string;
    /**
     * 
     * @type {number}
     * @memberof EmployeeCostsByJobRoleAndLocationSummary
     */
    totalPaidHours: number;
    /**
     * 
     * @type {number}
     * @memberof EmployeeCostsByJobRoleAndLocationSummary
     */
    estimatedTotal: number;
}

/**
 * Check if a given object implements the EmployeeCostsByJobRoleAndLocationSummary interface.
 */
export function instanceOfEmployeeCostsByJobRoleAndLocationSummary(value: object): value is EmployeeCostsByJobRoleAndLocationSummary {
    if (!('locationId' in value) || value['locationId'] === undefined) return false;
    if (!('locationName' in value) || value['locationName'] === undefined) return false;
    if (!('jobRoleId' in value) || value['jobRoleId'] === undefined) return false;
    if (!('jobRoleName' in value) || value['jobRoleName'] === undefined) return false;
    if (!('totalPaidHours' in value) || value['totalPaidHours'] === undefined) return false;
    if (!('estimatedTotal' in value) || value['estimatedTotal'] === undefined) return false;
    return true;
}

export function EmployeeCostsByJobRoleAndLocationSummaryFromJSON(json: any): EmployeeCostsByJobRoleAndLocationSummary {
    return EmployeeCostsByJobRoleAndLocationSummaryFromJSONTyped(json, false);
}

export function EmployeeCostsByJobRoleAndLocationSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmployeeCostsByJobRoleAndLocationSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'locationId': json['locationId'],
        'locationName': json['locationName'],
        'jobRoleId': json['jobRoleId'],
        'jobRoleName': json['jobRoleName'],
        'totalPaidHours': json['totalPaidHours'],
        'estimatedTotal': json['estimatedTotal'],
    };
}

  export function EmployeeCostsByJobRoleAndLocationSummaryToJSON(json: any): EmployeeCostsByJobRoleAndLocationSummary {
      return EmployeeCostsByJobRoleAndLocationSummaryToJSONTyped(json, false);
  }

  export function EmployeeCostsByJobRoleAndLocationSummaryToJSONTyped(value?: EmployeeCostsByJobRoleAndLocationSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'locationId': value['locationId'],
        'locationName': value['locationName'],
        'jobRoleId': value['jobRoleId'],
        'jobRoleName': value['jobRoleName'],
        'totalPaidHours': value['totalPaidHours'],
        'estimatedTotal': value['estimatedTotal'],
    };
}

